<div class="container-checkbox-input" [class.checkbox-is-disabled]="disabled" [class.checkbox-is-checked]="value === true" (click)="onClickCheckbox()">
  <div class="checkbox-icon">
    <span class="fas fa-fw fa-check"></span>
  </div>
  <ng-content></ng-content>
</div>